import { v4 as uuidv4 } from "uuid";
import { ILichThiSinhVienActionTypes } from '../../action-types/tct/ILichThiSinhVienActions';
import { eReducerStatusBase } from '../../reducer-model/eReducerStatusBase';
import { ILichThiSinhVienReducer, ILichThiSinhVienReducerData } from '../../reducer-model/tct/ILichThiSinhVienReducer';


const iniTab: ILichThiSinhVienReducerData = {
    id: uuidv4(),
    title: "Untitled",
    status: eReducerStatusBase.is_not_initialization,
};
const iniState: ILichThiSinhVienReducer = {
    selectedId: iniTab.id,
    sinhViens: [iniTab],
    dotThiId: 0

};
export const lichThiSinhVienReducer = (state: ILichThiSinhVienReducer = iniState, action: ILichThiSinhVienActionTypes): ILichThiSinhVienReducer => {
    switch (action.type) {
        case 'LICH_THI_SINH_VIEN_ADD_NEW_TAB':
            const id = uuidv4();
            return {
                ...state,
                selectedId: id,
                sinhViens: [{
                    ...iniTab,
                    title: action.payload?.ho_ten ?? "Untitled",
                    id: id,
                    sinhVien: action.payload

                }, ...state.sinhViens],
            };
        case 'LICH_THI_SINH_VIEN_REMOVE_TAB':
            return {
                ...state,
                sinhViens: state.sinhViens.filter((t) => t.id !== action.payload),
            };
        case 'LICH_THI_SINH_VIEN_UPDATE_TAB_DATA':
            return {
                ...state,
                sinhViens: state.sinhViens.map((t) => {
                    if (t.id === action.payload.id) {
                        return action.payload;
                    }
                    return t;
                }),
            };
        case 'LICH_THI_SINH_VIEN_CHANGEG_SELECTED_TAB':
            return {
                ...state,
                selectedId: action.payload,
            };
        case "LICH_THI_SINH_VIEN_CHANGE_DOT_THI_ID":
            return {
                ...state,
                dotThiId: action.payload,
            };
        default:
            return state;
    }
}